import { TriangleAlert, Car } from "lucide-react";
import { fmtTime } from "./palette";

const human = (mins) => {
  if (mins < 60) return `${mins} minutes`;
  const hours = Math.floor(mins / 60);
  const rest = mins % 60;
  return `${hours} hour${hours === 1 ? "" : "s"}${rest ? ` ${rest} minutes` : ""}`;
};

export const TravelWarning = ({ warnings, clock }) => {
  if (!warnings?.length) return null;
  return (
    <div className="mt-3 space-y-1.5 rounded-xl border border-orange-400/40 bg-orange-400/10 p-3"
         data-testid="travel-warnings">
      <p className="inline-flex items-center gap-2 text-[11px] font-semibold uppercase tracking-widest text-orange-300">
        <TriangleAlert className="h-3.5 w-3.5" /> That is a tight turnaround
      </p>
      {warnings.map((w) => (
        <p key={`${w.from}-${w.to}-${w.starts}`} className="text-xs text-orange-100/90"
           data-testid={`travel-warning-${w.starts}`}>
          <Car className="me-1 inline h-3 w-3" />
          <span className="font-semibold">{w.from}</span> ends at {fmtTime(w.leaves, clock)} in {w.from_place},
          then <span className="font-semibold">{w.to}</span> starts at {fmtTime(w.starts, clock)} in {w.to_place}.
          That is about {w.km} km — roughly {human(w.need)} of travelling, and you only have {human(w.gap)}.
          You are short by about {human(w.short_by)}.
        </p>
      ))}
    </div>
  );
};
